import { render } from "./Test.vue?vue&type=template&id=5b2d5ecc"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Test.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b2d5ecc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b2d5ecc', __exports__)) {
    api.reload('5b2d5ecc', __exports__)
  }
  
  module.hot.accept("./Test.vue?vue&type=template&id=5b2d5ecc", () => {
    api.rerender('5b2d5ecc', render)
  })

}


export default __exports__